import type { ReactNode } from 'react';

import { PageTransition } from '../Transitions/PageTransition';

/** The centred logo + card layout of the sign-in pages. */
export function AuthShell({ title, subtitle, children, footer }: { title: string; subtitle?: string; children: ReactNode; footer?: ReactNode }) {
  return (
    <PageTransition>
      <div className="min-h-screen flex items-center justify-center bg-background py-12 px-4">
        <div className="max-w-md w-full">
          <div className="text-center mb-8">
            <svg className="w-14 h-14 mx-auto" viewBox="0 0 100 100" fill="none" aria-hidden="true">
              <rect width="100" height="100" rx="22" fill="#0d7377" />
              <path d="M28 72 Q28 44 50 32 Q72 44 72 72" fill="none" stroke="white" strokeWidth="5.5" strokeLinecap="round" />
              <path d="M36 72 Q36 52 50 44 Q64 52 64 72" fill="none" stroke="white" strokeWidth="5.5" strokeLinecap="round" opacity="0.35" />
              <line x1="50" y1="20" x2="50" y2="32" stroke="white" strokeWidth="5.5" strokeLinecap="round" />
              <circle cx="50" cy="18" r="4" fill="white" />
            </svg>
            <h1 className="mt-4 text-3xl font-bold text-text-primary [text-wrap:balance]">{title}</h1>
            {subtitle && <p className="mt-2 text-text-muted [text-wrap:pretty]">{subtitle}</p>}
          </div>
          <div className="bg-surface rounded-xl shadow-sm border border-border p-8">{children}</div>
          {footer && <div className="mt-6 flex flex-col items-center gap-3 text-center text-sm text-text-muted">{footer}</div>}
        </div>
      </div>
    </PageTransition>
  );
}

export const authInput =
  'w-full px-4 py-3 border border-border rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent bg-background';
export const authLabel = 'block text-sm font-medium text-text-secondary mb-2';
export const authButton =
  'w-full py-3 bg-brand-primary text-white font-medium rounded-lg hover:bg-brand-secondary disabled:opacity-50 transition-colors';
